import lang from '@/plugins/lang'
import Toastify from '@/plugins/toastify'
import { requestPermission } from '@/plugins/push-notification/requestPermission'
import { getStorageItem, setStorageItem } from '@/helpers/storage'
import { waitDOMContentLoaded } from '@/helpers/DOM'

let flagForceToastNotification = false

let toast = null;

async function showToastify(options, checkSStorage) {
    await waitDOMContentLoaded()

    if (checkSStorage && !flagForceToastNotification && getStorageItem('closed_toast_push_notification') === '1') {
        return
    }

    if (checkSStorage) {
        options.callback = function() {
            setStorageItem('closed_toast_push_notification', '1')
        }
    }

    if (toast && toast.options.text === options.text) {
        return toast
    }

    if (toast) {
        toast.hideToast()
    }

    return toast = Toastify(options).showToast()
}

// --------- Toast About API Notification Push Permission -----------------
export function toastNeedNotificationPermission() {
    return showToastify({
        title: lang.t('toast:notification_permissions.allow.title'),
        text: lang.t('toast:notification_permissions.allow.text'),
        duration: 0,
        buttons: [
            {
                text: lang.t('toast:button_request_permission'),
                onClick(event) {
                    requestPermission()
                },
                class: 'btn-success'
            },
        ]
    }, false)
}

export function toastBrowserNoSupport() {
    return showToastify({
        title: lang.t('toast:notification_permissions.noSupport.title'),
        text: lang.t('toast:notification_permissions.noSupport.text'),
        duration: 0,
    }, true)
}

export function toastDeniedNotification() {
    return showToastify({
        title: lang.t('toast:notification_permissions.denied.title'),
        text: lang.t('toast:notification_permissions.denied.text'),
        duration: 0,
    }, true)
}

export function toastBraveBlocked() {
    return showToastify({
        title: lang.t('toast:notification_permissions.braveBlocked.title'),
        text: lang.t('toast:notification_permissions.braveBlocked.text'),
        duration: 0,
    }, false)
}

export function forceToastNotification() {
    flagForceToastNotification = true
}
